'use client'
import { comparePageRouteSpecificity, matchesPageRoute } from './page-contracts'
import { createPageReadinessTelemetry } from './page-readiness-browser'

export type PageContentContract = {
  route: string
  domain: string
  phase: string
  /** Finite names of all required committed content gates. */
  parts: ReadonlyArray<string>
}

export function createPageContentTelemetry<Key extends string>(
  contracts: Readonly<Record<Key, PageContentContract>>
) {
  const gates = Object.fromEntries(
    Object.entries<PageContentContract>(contracts)
      .sort(([, left], [, right]) =>
        comparePageRouteSpecificity(left.route, right.route)
      )
      .map(([key, contract]) => [
        key,
        {
          ...contract,
          matches: (path: string) => matchesPageRoute(contract.route, path),
        },
      ])
  ) as Record<Key, PageContentContract & { matches: (path: string) => boolean }>
  return createPageReadinessTelemetry(gates)
}
